<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () { // 提供
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      lastTime: null, // 最后一次点击的时间
      currentTime: null, // 当前点击的时间
      timeOut: 30 * 60 * 1000// 设置超时时间:30分钟
    }
  },
  created () {
    // this.lastTime = new Date().getTime()
    this.refresh()
    // setInterval(() => { this.refresh() }, 900000) // 超时退出
    setInterval(() => {
      this.refresh()
    }, 900000)
  },

  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    async refresh () {
      const res = await this.$axios.get('/public/check/login')
      const path = this.$route.path
      try {
        if (path === '/moreVersion') {
          this.$router.push("/moreVersion")
        } else {
          if (res.data.errCode == -1) {
            setTimeout(() => {
              this.$router.push("/")
              window.localStorage.clear()
              window.sessionStorage.clear()
            }, 300)

            //   // this.$router.push('/view/Login')
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    isTimeOut () {
      this.currentTime = new Date().getTime() // 记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
        this.lastTime = new Date().getTime()
        this.$router.push('/view/Login')
      } else {
        this.lastTime = new Date().getTime() // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
        // console.log('login3')
      }
    }
  }
}
</script>

<style lang="scss">
@media only screen and (max-width: 930px) {
  #app {
    width: 940px !important;
  }
}

#app {
  font-family: 微软雅黑, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
  /* width: 1920px; */
  // background: rgb(241, 249, 255) ;
}

body,
html,
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

/* 日历修改样式 要放在全局调用 不然不生效*/
.x-hd div span {
  border: 1px solid #409EFF;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue